/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { FamiliarData, PersonalData } from '../../types/PersonalData';
import HeadingDatoContacto from './HeadingDatoContacto';
import { IconPencil } from '../../Icons';
import { useMisDatosStore } from './context/MisDatos.context';

type Props = {
  loadModal: (data: PersonalData) => void;
  getData: () => void;
  isFamilyData: boolean;
  personalData: PersonalData;
  familiarData: FamiliarData;
  promiseApi: boolean;
};
const ContactDataView: FC<Props> = ({ personalData }) => {
  const { t } = useTranslation();
  const { showModalContactEmail, showModalTelefono1 } = useMisDatosStore();

  return (
    <>
      <div className="divider" />
      <div className="bloque-datos">
        <HeadingDatoContacto />

        <div className="bloque-datos__datos">
          <ul className="bloque-datos__list">
            {personalData.telefono && (
              <li>
                <p className="bloque_usuario">
                  {t('datos.personaldata.phone')}:&nbsp;
                  <strong>{personalData.telefono}</strong>
                  <a
                    className="bloque-datos__action"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      document.body.classList.add('fix');
                      showModalTelefono1();
                    }}
                  >
                    <span className="hidden">
                      Enlace a la edicion del bloque
                    </span>
                    <span className="icon icon__stroke icon-round">
                      <IconPencil />
                    </span>
                  </a>
                </p>
              </li>
            )}
            {personalData.emailContacto && (
              <li>
                <p className="bloque_usuario">
                  {t('datos.personaldata.email')}:&nbsp;
                  <strong>{personalData.emailContacto}</strong>
                  <a
                    className="bloque-datos__action edit-email"
                    onClick={(e) => {
                      e.preventDefault();
                      e.stopPropagation();
                      document.body.classList.add('fix');
                      showModalContactEmail();
                    }}
                  >
                    <span className="hidden">
                      Enlace a la edicion del bloque
                    </span>
                    <span className="icon icon__stroke icon-round">
                      <IconPencil />
                    </span>
                  </a>
                </p>
              </li>
            )}
          </ul>
        </div>
      </div>
    </>
  );
};

export default ContactDataView;
